import {useMemo} from 'react';
import type {GetValueById} from 'schema/form/types';
import type {Product} from 'services/metadata/types';

const preferredLanguages = ['nob', 'nno', 'nor', 'eng'];

export const useManifestationDescription = (
  getEditValue: GetValueById,
  manifestationId: string,
): string | undefined => {
  const products = getEditValue('products', manifestationId) as
    | Product[]
    | undefined;

  return useMemo(() => {
    if (!products) return undefined;

    const allDescriptions = products.flatMap(p => p.descriptions ?? []);
    if (allDescriptions.length === 0) return undefined;

    for (const lang of preferredLanguages) {
      const match = allDescriptions.find(d => d.language === lang);
      if (match) return match.content;
    }

    return allDescriptions[0]?.content;
  }, [products]);
};
